import { render } from "./scanCodePayModel.vue?vue&type=template&id=e520d8f2"
import script from "./scanCodePayModel.vue?vue&type=script&lang=js"
export * from "./scanCodePayModel.vue?vue&type=script&lang=js"

import "./scanCodePayModel.vue?vue&type=style&index=0&id=e520d8f2&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__